<!-- Main container that constrains everything to viewport height -->
<div class="main-container">
  <app-window-title
    [bottomBorder]="false"
    [centeredTitle]="currentFolderName"
    [closable]="true"
    [title]="Labels.clientMatterLabel + ': ' + patientName"
    (closed)="handleWindowTitleClose()"></app-window-title>

  <!-- Patient Identification Labels -->
  <app-patient-identification-labels
    [patient]="patient"
    [patientName]="patientName"
    [userOwnerID]="userOwnerID"></app-patient-identification-labels>

  <!-- Top Buttons Section -->
  <app-client-profile-top-buttons
    *ngIf="patientName !== '...'"
    [addClientUploadCondition]="addClientUploadCondition"
    [currentFolderName]="currentFolderName"
    [importFromAppsBtn]="importFromAppsBtn"
    [isSpoke]="isSpoke"
    [patientType]="patient?.type"
    [permissions_uploadfiles]="permissions_uploadfiles"
    [realRole]="realRole"
    [selectedHub]="true"
    [UserRoles]="UserRoles"
    (addConsultantEvent)="addFacilityConsultant()"
    (addDiagnosesEvent)="addDiagnoses()"
    (backToOverviewEvent)="backToOverview()"
    (handleAddClientUser)="handleAddClientUser($event)"
    (libraryManagerEvent)="showLibraryManager()"
    (openDialogEvent)="openDialog($event)"
    (shareFilesEvent)="openShareFilesDialog()"
    (showMyDiagnosesEvent)="showMyDiagnoses()"></app-client-profile-top-buttons>

  <div
    *ngIf="patientName !== '...'"
    class="main-content-section main-content-section-inline">
    <div
      class="content-wrapper fx-col"  >
      <div
        class="content-header content-header-inline fx-row fx-col-xs fx-jc-between fx-ai-start fx-jc-start-xs fx-ai-start-xs fx-gap-20 fx-gap-16-xs"  >
        <div
          class="content-main content-main-inline fx-col fx-gap-12"  >
          <div
            *ngIf="loadingPermissions"
            class="loader-container loader-container-inline fx-row fx-jc-start fx-ai-center"  >
            <app-loader></app-loader>
          </div>
        </div>

        <!-- Client Profile Notifications -->
        <div
          class="notifications-container notifications-container-inline fx-col fx-row-xs fx-jc-start-xs fx-ai-center-xs fx-gap-8 fx-gap-12-xs"  >
          <app-notifications  class="fx-gap-12"[notifications]="clientProfileNotifications"
            (clickAction)="onNotificationClick($event)"></app-notifications>
        </div>
      </div>

      <div
        class="client-profile-layout client-profile-layout-inline fx-col"  >
        <!-- MAIN CONTENT PANEL -->
        <div
          class="main-panel main-panel-inline fx-col"  >
          <!-- Client Profile Toolbar -->
          <app-client-profile-toolbar
            [files]="files"
            [permissions_createfolder]="permissions_createfolder"
            [refreshButton]="refreshButton"
            (createFolderEvent)="createFolder()"
            (handleRefreshEvent)="handleRefresh()"
            (openFileSearchEvent)="openFileSearch()"></app-client-profile-toolbar>

          <div  class="fx-row">
            <div
              fxFlex  class="fx-col">
              <div
                id="home-folders-accordion"
                class="home-folders-accordion-container-box">
                <app-documents-to-share
                  #homeFoldersAccordion
                  [casename]="casename"
                  [currentFolderName]="currentFolderName"
                  [discsFolderName]="discsFolderName"
                  [folders]="isClientAdmin() ? accordionFolders : hierarchicalFolders"
                  [isSearchActive]="isSearchActive"
                  [loading]="loading"
                  [loadingMessage]="loadingMessage"
                  [ownerID]="ownerID"
                  [permissions]="permissions"
                  [searchQuery]="searchQuery"
                  [searchResults]="searchResults"
                  [userOwnerID]="userOwnerID"
                  (addCommentOrAttachment)="handleAccordionAddCommentOrAttachment($event)"
                  (allFoldersClosed)="handleAllFoldersClosed()"
                  (clearSearchResults)="onClearSearchResults()"
                  (copyFile)="handleAccordionCopyFile($event)"
                  (createFolder)="createFolder(currentFolder, { folderName: currentFolderName })"
                  (createSubfolder)="handleCreateSubfolder($event)"
                  (deleteFile)="handleAccordionDeleteFile($event)"
                  (deleteFolder)="handleAccordionDeleteFolder($event)"
                  (editFile)="handleAccordionEditFile($event)"
                  (fileClick)="handleAccordionFileClick($event)"
                  (folderClick)="handleAccordionFolderClick($event)"
                  (folderNameClick)="handleAccordionFolderNameClick($event)"
                  (folderSelectionChange)="handleAccordionSelectionChange($event)"
                  (generateDisc)="handleAccordionGenerateDisc($event)"
                  (loadFolderContents)="handleLoadFolderContents($event)"
                  (refreshFolderContents)="handleRefreshFolderContents($event)"
                  (searchResultFileClick)="onSearchResultFileClick($event)"
                  (searchResultFileSelectionChange)="onSearchResultFileSelectionChange($event)"
                  (sharedIconClick)="handleAccordionSharedIconClick($event)"
                  (studyClick)="handleAccordionStudyClick($event)"></app-documents-to-share>
                <!-- Spoke Accordion (for HUB users) -->
                <app-shared-documents
                  *ngIf="isHub && showSpokesAsFolders"
                  #homeFoldersAccordionSpokes
                  [casename]="casename"
                  [hubName]="hubName"
                  [isHub]="isHub"
                  [loading]="loading"
                  [loadingMessage]="loadingMessage"
                  [permissions]="permissions"
                  [selectedSpoke]="selectedSpoke"
                  [sharerSpokes]="sharerSpokes"
                  [showSpokesAsFolders]="showSpokesAsFolders"
                  (addCommentOrAttachment)="handleAccordionAddCommentOrAttachment($event)"
                  (allFoldersClosed)="handleAllFoldersClosed()"
                  (copyFile)="handleAccordionCopyFile($event)"
                  (deleteFile)="handleAccordionDeleteFile($event)"
                  (editFile)="handleAccordionEditFile($event)"
                  (fileClick)="handleAccordionFileClick($event)"
                  (folderSelectionChange)="handleAccordionSelectionChange($event)"
                  (generateDisc)="handleAccordionGenerateDisc($event)"
                  (sharedIconClick)="handleAccordionSharedIconClick($event)"
                  (spokeClick)="selectSpoke($event)"
                  (studyClick)="handleAccordionStudyClick($event)"></app-shared-documents>
              </div>

              <!-- INFECTED FILES SECTION -->
              <div
                *ngIf="infectedFiles && infectedFiles.length"
                class="infected-files-section mat-small">
                <p>
                  The following file(s) has been deleted because of malware found in it. Please click
                  <a
                    class="refresh-link refresh-link-inline"
                    href="#"
                    (click)="goRefresh($event)">
                    REFRESH
                  </a>
                  to update the list of files
                </p>
                <ul>
                  <li
                    *ngFor="let file of infectedFiles"
                    class="infected-file infected-file-item">
                    {{ file }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
